import React, { Component } from "react";
import GLOBALS from '../utils/Constants';

export default class UtilsService {

    static sharedInstance = UtilsService.sharedInstance == null ? new UtilsService() : this.sharedInstance;

    checkIfValidArray(value){
        try{
            return  Array.isArray(value);
        }
        catch(e){
           return false;
        }
    }

    checkIfValidObject(value){
        return typeof(value) == "object";
    }

    checkIfValidObjectOrArray(value){
        return this.checkIfValidArray(value) || this.checkIfValidObject(value);
    }

    formatJSON(value){
        let tempJSON = [];
        try{
            tempJSON = JSON.parse(value);
        }
        catch(e){
            tempJSON = [];
        }
        return tempJSON;
    }

    isUndefinedOrNull(value){
        return typeof(value) == "undefined" || value == null;
    }

    tryParseJSON (jsonString){
        try {
            var o = JSON.parse(jsonString);
            if (o && typeof o === "object") {
                return o;
            }
        }
        catch (e) { }

        return false;
    }

    convertStringToArray(object){
       return (typeof object === 'string') ? Array(object) : object 
    }
}